import { useSyncExternalStore } from "react";

const pendingBranches = new Set<string>();
const listeners = new Set<() => void>();

function publish() {
  for (const listener of listeners) listener();
}

function markBranchServerPending(branchId: string) {
  pendingBranches.add(branchId);
  publish();
}

function markBranchServerReady(branchId: string) {
  pendingBranches.delete(branchId);
  publish();
}

export function trackOptimisticBranch(
  branchId: string,
  server: Promise<{ type: string }>,
  onFailure: () => void
) {
  markBranchServerPending(branchId);
  const failIfCurrent = () => {
    if (new URLSearchParams(location.search).get("branch") === branchId) {
      onFailure();
    }
  };
  void server
    .then((result) => {
      if (result.type === "error") failIfCurrent();
    }, failIfCurrent)
    .then(
      () => markBranchServerReady(branchId),
      () => markBranchServerReady(branchId)
    );
}

export function useBranchServerReady(branchId: string) {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => !pendingBranches.has(branchId),
    () => true
  );
}
